export const REVIEWER_TYPES = {
  SELF: 'self',
  MANAGER: 'manager',
  PEERS: 'peers',
  REPORTEES: 'reportees',
  MANUAL: 'manual',
}
